/*eslint-disable*/
import React, { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
import { Link, useHistory } from 'react-router-dom'

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'About Us', href: '/about' },
  { name: 'Service', href: '/service' },
  { name: 'Contact Us', href: '/contact' }
]

export default function Navbar() {
  const history = useHistory()

  return (
    <div className='relative'>
      <div className='z-10 pb-8 bg-white sm:pb-16 lg:w-full'>
        <Popover>
          <div className='relative pt-6 px-4 sm:px-6 lg:px-8'>
            <nav
              className='w-full relative flex items-center justify-between sm:h-10'
              aria-label='Global'
            >
              <div className='flex items-center justify-between w-full md:w-auto'>
                <Link to='/' className='flex items-center cursor-pointer'>
                  <img
                    className='h-8 w-auto sm:h-10'
                    src='/logo.png'
                    alt='Oya!'
                  />
                  <span className='pl-1 font-bold text-3xl Oya-Logo-text'>Oya!</span>
                </Link>
                <div className='-mr-2 flex items-center md:hidden'>
                  <Popover.Button className='bg-white rounded-md inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500'>
                    <span className='sr-only'>Open main menu</span>
                    <MenuIcon
                      className='h-8 w-10 text-black'
                      aria-hidden='true'
                    />
                  </Popover.Button>
                </div>
              </div>

              <div className='hidden md:block lg:ml-10 md:pr-4 sm:space-x-4 md:space-x-6 lg:space-x-8'>
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`font-medium text-gray-500 pb-1 hover:text-gray-900 border-b-2 border-transparent hover:border-gray-500 transition-colors duration-1000 ease-out
                      ${
                        history.location.pathname === item.href &&
                        'border-gray-500'
                      }
                    `}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>

              <div className='hidden md:block font-medium sm:space-x-6 md:space-x-8'>
                <a
                  href='/'
                  className='text-oya-ghana-green hover:text-green-500'
                >
                  Log in
                </a>

                <a
                  href='/'
                  className='p-3 rounded-md text-white bg-oya-ghana-green hover:bg-green-500'
                >
                  Sign Up
                </a>
              </div>
            </nav>
          </div>

          <Transition
            as={Fragment}
            enter='duration-150 ease-out'
            enterFrom='opacity-0 scale-95'
            enterTo='opacity-100 scale-100'
            leave='duration-100 ease-in'
            leaveFrom='opacity-100 scale-100'
            leaveTo='opacity-0 scale-95'
          >
            <Popover.Panel
              focus
              className='absolute top-0 inset-x-0 transition transform origin-top-right md:hidden'
              style={{ zIndex: '1000000' }}
            >
              <div className='bg-white pb-6 shadow-lg overflow-hidden'>
                <div className='px-5 pt-6 flex items-center justify-between'>
                  <Link to='/' className='flex items-center cursor-pointer'>
                    <img
                      className='h-5 w-auto sm:h-10'
                      src='/logo.png'
                      alt='Oya!'
                    />
                    <span className='pl-1 font-bold text-lg'>Oya</span>
                  </Link>
                  <div className='-mr-2'>
                    <Popover.Button className='bg-white rounded-md inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500'>
                      <span className='sr-only'>Close main menu</span>
                      <XIcon
                        className='h-8 w-10 text-black'
                        aria-hidden='true'
                      />
                    </Popover.Button>
                  </div>
                </div>

                <div className='flex flex-col justify-center items-center text-center px-2 pt-5 pb-3 space-y-1'>
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className='w-full block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100'
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>

                <div className='flex flex-col justify-center items-center pt-5'>
                  <a
                    href='/'
                    className='w-full px-3 py-2 text-center rounded-md font-medium text-black'
                  >
                    Log in
                  </a>
                  <Link href='/' className='w-full px-3 py-3 text-center'>
                    <span className='px-3 py-2 rounded-md text-white bg-oya-ghana-green'>
                      Sign Up
                    </span>
                  </Link>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>
      </div>
    </div>
  )
}
